// **React Imports
import React, { memo, useEffect, useRef, useState } from 'react'

// **MUI Imports
import { styled, CircularProgress } from '@mui/material'

const LoadingContainer = styled('div')(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  transform: 'translate(-50%,-50%)',
  zIndex: 10
}))

const MeetingVideoPlayer = ({
  videoStream,
  type,
  videoEleId,
  videoStyle = {},
  showPortrait = false
}) => {
  // Hooks
  const videoRef = useRef(null)
  const [loading, setLoading] = useState(true)

  // useEffect
  useEffect(() => {
    if (videoStream && videoRef.current) {
      videoRef.current.srcObject = videoStream
      videoRef.current.onloadeddata = () => {
        setLoading(false)
      }
    }
  }, [videoStream, type])

  const handleCanPlay = () => {
    setLoading(false)
  }

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden'
      }}
    >
      {loading && (
        <LoadingContainer>
          <CircularProgress />
        </LoadingContainer>
      )}
      <video
        {...(videoEleId ? { id: videoEleId } : {})}
        className={`${type || ''} ${showPortrait ? 'portrait-video' : ''}`}
        ref={videoRef}
        autoPlay
        muted
        onCanPlay={handleCanPlay}
        onContextMenu={(e) => {
          e.preventDefault()
        }}
        disablePictureInPicture={true}
        onError={(e) => console.log('Video playback error:', e)}
        style={{ width: '100%', height: '100%', ...videoStyle }}
      />
    </div>
  )
}

export default memo(MeetingVideoPlayer)
